import { render, staticRenderFns } from "./sTable.vue?vue&type=template&id=4ebd69f0"
import script from "./sTable.vue?vue&type=script&lang=ts"
export * from "./sTable.vue?vue&type=script&lang=ts"
import style0 from "./sTable.vue?vue&type=style&index=0&id=4ebd69f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports